import { render, staticRenderFns } from "./SharedItemsBrowser.vue?vue&type=template&id=d526fdee&scoped=true"
import script from "./SharedItemsBrowser.vue?vue&type=script&lang=js"
export * from "./SharedItemsBrowser.vue?vue&type=script&lang=js"
import style0 from "./SharedItemsBrowser.vue?vue&type=style&index=0&id=d526fdee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d526fdee",
  null
  
)

export default component.exports